import api from '@/api/helpfuls'
import errors from '@/api/errors'

const state = {}

const getters = {}

const mutations = {}

const actions = {
  /**
   * 役に立った登録
   */
  registerHelpful: ({ dispatch }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      reviewId: args.reviewId
    }
    return api.registerHelpful(params).then(data => {
      dispatch('storeReviews/setEntryHelpful', {
        reviewId: args.reviewId,
        isEntryHelpful: 1, // 1:役に立った登録済み
        helpfulId: data.helpful_id
      }, { root: true }).then(() => {
        dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      })
    }).catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  },
  /**
   * 役に立った解除
   */
  deleteHelpful: ({ dispatch }, args) => {
    dispatch('commons/setLoadingPost', { isLoading: true }, { root: true })
    dispatch('commons/clearGlobalError', {}, { root: true })
    const params = {
      helpfulId: args.helpfulId
    }
    return api.deleteHelpful(params).then(data => {
      dispatch('storeReviews/setEntryHelpful', {
        reviewId: args.reviewId,
        isEntryHelpful: 0 // 0:役に立った未登録
      }, { root: true }).then(() => {
        dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      })
    }).catch(error => {
      dispatch('commons/setLoadingPost', { isLoading: false }, { root: true })
      if (error instanceof errors.AuthenticationError) {
        dispatch('commons/setGlobalError', error, { root: true })
      } else {
        return Promise.reject(Error('問題が発生したため処理を継続することができませんでした。'))
      }
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/helpfuls.js